import { useField } from 'formik';
import React from 'react';

import { Checkbox, CheckboxProps, FormControlLabel } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

export type CheckboxWithLabelProps = {
  label: React.ReactNode;
  name: string;
  className?: string;
  showError?: boolean;
  disabled?: boolean;
  value?: string;
  testId?: string;
} & Pick<CheckboxProps, 'color' | 'checked' | 'onChange'>;


export const CheckboxWithLabel: React.FC<CheckboxWithLabelProps> = ({
  label,
  name,
  className,
  value,
  showError = false,
  color = 'primary',
  disabled = false,
  testId = `${name}-checkbox`,
  ...props
}) => {
  const { classes, cx } = useStyles();
  const [ field, meta ] = useField({ name, value, type: 'checkbox' });

  const hasError = showError && Boolean(meta.error) && meta.touched;

  return (
    <FormControlLabel
      label={label}
      className={cx(className, {
        [classes.error]: hasError,
      })}
      disabled={disabled}
      data-testid={testId}
      control={(
        <Checkbox
          color={color}
          className={hasError ? classes.error : undefined}
          {...field}
          {...props}
        />
      )}
    />
  );
};

const useStyles = makeStyles()((theme) => ({
  error: {
    color: theme.palette.error.main
  },
}));
